// 当页面加载完成或Shopify动态加载部分内容后执行
document.addEventListener('DOMContentLoaded', function() {
  checkSlideshowVisibility();
});

// 监听Shopify的section重新加载事件（如果您使用AJAX翻页则需要这个）
document.addEventListener('shopify:section:load', function() {
  checkSlideshowVisibility();
});

// 检查URL参数并决定是否隐藏幻灯片
function checkSlideshowVisibility() {
  // 解析URL参数
  const params = new URLSearchParams(window.location.search);
  const pageNum = parseInt(params.get('page') || '1');
  
  // 目标幻灯片元素 - 使用类选择器
  const slideshow = document.querySelector('.grid--flush-bottom') ||
    document.querySelector('#shopify-section-template--16617805840590__text_and_image_mK9Eyg .feature-row') ||
                    document.querySelector('.index-section--flush'); 
  
  // 如果找到了元素并且当前页码大于1
  if (slideshow) {
    if (pageNum > 1) {
      // 隐藏幻灯片
      slideshow.classList.add('slideshow-hidden');
    } else {
      // 确保在返回第一页时显示幻灯片
      slideshow.classList.remove('slideshow-hidden');
    }
  }
}